import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useUiTheme } from '@/hooks/use-ui-theme';
import OldTimeManagement from './time-management-old';
import MissionControlTimeManagement from './time-management-mission-control';
export default function POSTimeManagement(props) {
    const { uiTheme } = useUiTheme();
    return uiTheme === 'classic' ? (_jsx(OldTimeManagement, { ...props })) : (_jsx(MissionControlTimeManagement, { ...props }));
}
